import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Button,
  Col,
  Dropdown,
  Flex,
  Layout,
  Menu,
  Row,
  Space,
} from "antd";
import {
  UserOutlined,
  DashboardOutlined,
  MenuOutlined,
  CloseOutlined,
  LogoutOutlined,
  SettingOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import {
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import HeaderLogo from "../../assets/images/Logo(2).png";
import "../../assets/scss/Admin.scss";
import { useSocketEvents } from "../../socket/hooks/useSocketEvents";
import AdminIcon from "../../assets/icons/AdminIcon";
import { clearSharedSso } from "../../utils/ssoCookie";
const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [localdata, setlocaldata] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  const [companyLogoUrl, setcompanyLogoUrl] = useState(
    localStorage.getItem("companyLogoUrl") == undefined
      ? null
      : localStorage.getItem("companyLogoUrl")
  );
  const UserData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  const hasRunRef = useRef(false); // to ensure effect runs only once
  let rout = localdata?.domain || "elsnertech";

  const navigate = useNavigate();
  const location = useLocation();
  const { emit } = useSocketEvents();
  const [theme, setTheme] = useState("light");

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 767;
      setIsMobile(mobile);
      if (!mobile) {
        setMobileMenuVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
  };

  // Handle menu item click in mobile
  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (isMobile) {
      setMobileMenuVisible(false);
    }
  };

  const menuItems = [
    {
      key: "/admin/dashboard",
      label: "Dashboard",
      icon: <DashboardOutlined />,
      permission: ["Admin", "SuperAdmin"],
    },

    {
      key: "/admin/company-registartion",
      label: "Companies registration ",
      icon: <AdminIcon />,
      permission: ["Admin"],
    },
    {
      key: "/admin/settings",
      label: "Settings",
      icon: <SettingOutlined />,
      permission: ["Admin"],
    },

    {
      key: "/admin/Administrator",
      label: "Admins",
      icon: <AdminIcon />,
      permission: ["SuperAdmin"],
    }
  ];

  const items = [
    {
      key: "2",
      label: (
        <div className="logout-button" onClick={(e) => e?.stopPropagation()}>
          <Button
            onClick={() => {
              // Clear the shared SSO cookie first so sibling apps single-logout too.
              clearSharedSso();
              localStorage.clear();
              navigate("/");
              emit("logout", UserData?._id);
            }}
            icon={<LogoutOutlined />}
          >
            Logout
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const savedTheme = "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
    const checkbox = document.getElementById("toggleBtn");
    if (checkbox) {
      if (savedTheme === "light") {
        checkbox.classList.add("light-mode");
        checkbox.classList.remove("dark-mode");
      } else {
        checkbox.classList.add("dark-mode");
        checkbox.classList.remove("light-mode");
      }
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
    const checkbox = document.getElementById("toggleBtn");
    if (newTheme === "light") {
      checkbox.classList.add("light-mode");
      checkbox.classList.remove("dark-mode");
    } else {
      checkbox.classList.add("dark-mode");
      checkbox.classList.remove("light-mode");
    }
  };

  useEffect(() => {
    if (hasRunRef.current) return; // prevent multiple runs
    hasRunRef.current = true;

    // Conditionally add 'admin-user' class
    const path = window.location.pathname;
    const isAdminRoute = path.startsWith("/admin");
    const isAdminRole =
      localdata?.roleName === "Admin" || localdata?.roleName === "SuperAdmin";

    if (isAdminRoute && isAdminRole) {
      document.body.classList.add("admin-user");
      setTimeout(() => {
        document.body.classList.add("load-content");
      }, 250);
    } else {
      document.body.classList.remove("admin-user");
      setTimeout(() => {
        document.body.classList.remove("load-content");
      }, 0);
      if (document.body.classList.length === 0) {
        document.body.removeAttribute("class");
      }
    }
  }, [localdata]);

  return (
    <Layout className="app-wrapper admin" style={{ minHeight: "100dvh" }}>
      {/* Sidebar */}
      <Sider
        className="sidebar"
        width={120}
        style={{
          position: isMobile ? "fixed" : "relative",
          left: isMobile && !mobileMenuVisible ? "-180px" : "0",
          zIndex: isMobile ? 1000 : 1,
          height: isMobile ? "100vh" : "auto",
        }}
      >
        <div className="sidebar-header" style={{ position: "relative" }}>
          <div className="sidebar-logo">
            {console.log(companyLogoUrl, "companyLogoUrl")}
            <img
              src={companyLogoUrl || HeaderLogo}
              alt="Company Logo"
              onError={(e) => (e.currentTarget.src = HeaderLogo)}
            />
          </div>

          {/* Mobile Close Button */}
          {isMobile && (
            <button
              className="sidebar-close-btn"
              onClick={() => setMobileMenuVisible(false)}
              onMouseEnter={(e) => e.target}
              onMouseLeave={(e) => e.target}
            >
              <CloseOutlined />
            </button>
          )}
        </div>

        <Menu
          className="sidebar-menu"
          selectedKeys={[location.pathname]}
          onClick={handleMenuClick}
        >
          {menuItems.map((item) => {
            if (item.permission.includes(localdata?.roleName)) {
              return (
                <Menu.Item key={item.key} icon={item.icon}>
                  {item.label}
                </Menu.Item>
              );
            }
            return null;
          })}
        </Menu>
      </Sider>

      {/* Mobile overlay */}
      {isMobile && mobileMenuVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
          onClick={() => setMobileMenuVisible(false)}
        />
      )}

      {/* Main layout */}
      <Layout style={{ marginLeft: isMobile ? 0 : undefined }}>
        {/* Header */}
        <Header className="header">
          <Row className="header-wrapper">
            {/* Mobile menu button */}
            {isMobile && (
              <Button
                type="text"
                className="mobile-menu-button"
                icon={<MenuOutlined />}
                onClick={toggleMobileMenu}
                style={{
                  fontSize: "14px",
                  width: 35,
                  height: 35,
                }}
              />
            )}

            <Col flex="auto">
              <Flex justify="end" align="center" gap="small" className="menu-controls">
                {(localdata?.roleName === 'Admin' && localdata?.companyId) && (

                  <div style={{ border: "1px solid #fff", borderRadius: "12px" }}>
                    {/* <Tooltip title="Go to the e-connect chat"> */}
                    <Button
                      icon={<MessageOutlined />}
                      onClick={() => {
                        navigate(
                          `/${rout}/welcome`
                        );
                        window.dispatchEvent(new CustomEvent('registerSocket', { detail: localdata?._id }));
                      }}>
                      Go to Chat
                    </Button>
                    {/* </Tooltip> */}
                  </div>
                )}
              </Flex>
            </Col>
            <Col>
              <Dropdown
                menu={{ items }}
                placement="bottomRight"
                arrow={{ pointAtCenter: true }}
                trigger={["click"]}
                dropdownRender={(menu) => <div>{menu}</div>}
              >
                <Button
                  type="text"
                  className="user-button"
                  placement="bottomRight"
                >
                  <Space>
                    <span>{localdata?.userName || "User"}</span>
                    <Avatar
                      className="user-avatar"
                      src={localdata?.profilePic} // Use profile pic if available
                      icon={!localdata?.profilePic && <UserOutlined />}
                    />
                  </Space>
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </Header>

        {/* Content Area */}
        <Content>
          <div
            className="content-wrapper"
            style={{
              Height: "100vh",
              maxHeight: "calc(100vh - 66px)",
              overflowY: "auto",
              padding: "10px",
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
